/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type SessionTypeOptionTypeEnum =
  (typeof SessionTypeOptionTypeEnum)[keyof typeof SessionTypeOptionTypeEnum];

export const SessionTypeOptionTypeEnum = {
  'single-session': 'single-session',
  consultation: 'consultation',
  'bundle-offering': 'bundle-offering',
  'bundle-relationship': 'bundle-relationship',
} as const;
